import { ReactElement } from 'react'
import { RoofForm } from '@structuralPlanningComponents'
import { CorneredSection } from '@ui2/structure'
import { useEditElementStore } from '@editorStores'
import { useScopedSelectionReset } from '@editorHooks'
import { useDisableIFCSelection } from 'src/state/hooks'

/**
 * Reuses Structural Planning's roof (3D) drawing tool ("Dachflächen (3D)") inside the IFC importer.
 * Renders `RoofForm`, which makes roof slabs clickable and registers the scene editing itself. IFC/
 * GLB model selection is suppressed so scene clicks act on the roof slabs, and the selection is
 * cleared on leave.
 */
const IFCRoofDrawPanel = (): ReactElement => {
  const activeElement = useEditElementStore(state => state.activeElement)
  const setActiveElement = useEditElementStore(state => state.setActiveElement)

  useDisableIFCSelection(true)

  useScopedSelectionReset()

  return (
    <CorneredSection>
      <RoofForm selectedElement={activeElement} selectElement={setActiveElement} />
    </CorneredSection>
  )
}

export default IFCRoofDrawPanel
